var App = App || {};

App.WidgetFaq = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {
            selector.each(function () {

                const accordions = $(this).find(".accordion");

                accordions.each(function () {

                    const component = $(this).parents(".widget.faqs");
                    const accordion = $(this);
                    const viewMore = component.find(`button[aria-controls=\"${accordion.attr("id")}\"]`);

                    viewMore.on("click", function () {
                        if ($(this).attr("aria-expanded") == "false") {
                            $(this).attr("aria-expanded", "true").html("<span class=\"arrow-back\"><span class=\"fa-regular fa-minus\" aria-hidden=\"true\"></span>&#xFEFF;</span>Show less");
                            accordion.find(".accordion-item.d-none").addClass("accordion-item-conditional").removeClass("d-none");
                        }
                        else if ($(this).attr("aria-expanded") == "true") {
                            $(this).attr("aria-expanded", "false").html("<span class=\"arrow-back\"><span class=\"fa-regular fa-plus\" aria-hidden=\"true\"></span>&#xFEFF;</span>Show more");
                            accordion.find(".accordion-item.accordion-item-conditional").removeClass("accordion-item-conditional").addClass("d-none");
                        }
                    });
                });
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);